import { TESTIMONIALS } from '../constants/content';
import { useScrollAnimation } from '../hooks/useScrollAnimation';

export default function Testimonials() {
  const ref = useScrollAnimation();

  return (
    <section ref={ref} className="fade-in mx-auto w-full max-w-6xl px-4 py-16 md:px-8">
      <h2 className="font-[Nunito] text-3xl font-extrabold text-[#5B3FA6] md:text-4xl">Parents love it</h2>
      <p className="mt-3 text-lg text-[#6F655E]">Real families, real results.</p>
      <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {TESTIMONIALS.map((item, index) => (
          <article
            key={item.name}
            className="testimonial-card rounded-2xl border-l-4 border-[#D8CAF8] bg-white p-6 shadow-sm transition-all hover:-translate-y-1 hover:shadow-md"
            style={{ transitionDelay: `${index * 100}ms` }}
          >
            <p className="text-lg">⭐⭐⭐⭐⭐</p>
            <p className="mt-4 text-[#5F5650]">{item.quote}</p>
            <div className="mt-6 flex items-center gap-3">
              <span className={`${item.colorClass} inline-flex h-10 w-10 items-center justify-center rounded-full text-sm font-bold text-white`}>
                {item.initials}
              </span>
              <div>
                <p className="font-semibold text-[#4A3F66]">{item.name}</p>
                <p className="text-sm text-[#7B716A]">{item.role}</p>
              </div>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}

